export const iconFontAwesomeHandsThumbsUp = (
	<i className="fa-solid fa-thumbs-up"></i>
);
